<template>
  <div class="right" style="width:100%;overflow: hidden;">

    <rightTop @data="getCreditDataFn"></rightTop>


    <div class="rightCenter">
      <div class="centerTit">并购重组</div>
      <div style="width:80%;position: relative;">
        <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;">
          <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
          <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
        </div>
        
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <el-table
          border
          :fit="true"
          size="mini"
          :data="tableData"
          :header-cell-style="cellStyle">
          <el-table-column width="60" :show-overflow-tooltip="true" label="序号">
            <template slot-scope="scope">
              {{scope.$index+1+(currentPage4-1)*limit}} 
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="200"
            prop="hcomname"
            label="交易标的">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="200"
            prop="scomname"
            label="买方">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="200"
            prop="ggomname"
            label="卖方">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="100"
            prop="jyje"
            label="交易金额(万元)">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="bzname"
            label="币种">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="130"
            prop="zrbl"
            label="股权转让比例(%)">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="objtype"
            label="标的类型">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="zrfs"
            label="并购方式">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="jd"
            label="最新进展">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="130"
            prop="scggrq"
            label="披露日期">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="detail"
            label="详情">
            <template slot-scope="scope">
              <el-button @click="handleClickDetail(scope.row)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width:100%;margin-top:40px;">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
      },
      tableData:[],
      companyList:[],
      paramsData:{},//URL参数集合
      offset:0,//page
      limit:10,
      total:0,
      currentPage4:1
    };
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.paramsData.companyName = data[0].companyFullName;
      // this.paramsData.stockCode = "300034";
      // this.paramsData.enterpriseCode = '96cd49d4-7e23-11ea-b3e3-005056b8154d';
      this.fetchTable();//获取表格数据
    },
    //点击详情页跳转函数
    handleClickDetail(val){
      console.log(val,'val');
      let {href}=this.$router.resolve({
        path: "/reorganizationdetail",
        query: {
          bgczCode:val.bgczCode,//并购重组详情编码
          dbcode: this.$route.params.dbcode,
          company:this.paramsData.companyName
        }
      });
      window.open(href,'_blank')
    },
    cellStyle(row,column,rowIndex,columnIndex){
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    // 分页函数
    handleCurrentChange(val) {//当前页
      this.currentPage4 = val;
      this.offset = (val-1)*this.limit;
      this.fetchTable();
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/matters/downBgczData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    fetchTable(){
        let _this = this;
        let params = { 
          stockCode:this.paramsData.stockCode,  
          enterpriseCode:this.paramsData.enterpriseCode,  
          offset:this.offset,
          limit:this.limit
        }
        api.reorganizationOne(params).then(res=>{
            let data = res.data.rows;
            // _this.total = Math.ceil(Number(res.data.total)/Number(_this.limit));
            _this.total = res.data.total;
            console.log(data,'data');
            _this.tableData = data;
        })   
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; color: #dfecf7; }
.mailTable tr td.column { background-color: #375572;  color: #dfecf7; font-size:14px;font-weight:bold;width:20%;}
</style>


// WEBPACK FOOTER //
// src/view/majorevents/reorganization.vue